import { render, staticRenderFns } from "./statementDc.vue?vue&type=template&id=71e60ec2&scoped=true"
import script from "./statementDc.vue?vue&type=script&lang=js"
export * from "./statementDc.vue?vue&type=script&lang=js"
import style0 from "./statementDc.vue?vue&type=style&index=0&id=71e60ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e60ec2",
  null
  
)

export default component.exports